import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConstService } from './const.service';

@Injectable({
  providedIn: 'root'
})
export class CallApiService {

  constructor(private httpClient: HttpClient, private constService: ConstService) { }

  callApi(): Promise<any> {
    const apiUri = this.constService.getApiUri();
    return this.httpClient.get(apiUri).toPromise();
  }
}
